import { DomainSecurityLevel } from './Catalogs'

const RecoveryPasswordDetails: Readonly<{ [securityLevel: number]: string[] }> =
  {
    [DomainSecurityLevel.HIGH]: [
      'Tener entre 8 y 32 caracteres',
      'Incluir mayúsculas y minúsculas',
      'Incluir al menos un número',
      'Incluir al menos un símbolo'
    ],
    [DomainSecurityLevel.MEDIUM]: [
      'Tener entre 6 y 32 caracteres',
      'Incluir al menos una letra',
      'Incluir al menos un número'
    ],
    [DomainSecurityLevel.LOW]: ['Tener entre 4 y 32 caracteres']
  }

interface RecoveryPasswordRequest {
  domain: string
  user: string
  pin: string
  newPassword: string
}

export { RecoveryPasswordDetails, RecoveryPasswordRequest }
